import { BaseRouteService } from "core/services";

class TrackingCaseDocumentRouteService extends BaseRouteService {
    constructor() {
        super("tracking-case-documents");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,trackingCaseId}`, filter);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(`${this.base}/{id}`, resource);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }

	submit(resource) {
		return super.update(`${this.base}/submit/{id}`, resource);	
	}	

    populate(resource) {
        return super.update(`${this.base}/populate/{id}`, resource);
    }
}

export default TrackingCaseDocumentRouteService;